export default __webpack_public_path__ + "static/media/wealth_raffle_turn_icon2.a57048a4.png";